import { BaseSchema } from './baseSchema';
export class BaseTrySchema extends BaseSchema {
    constructor({ result, statusCode, componentName, componentSource, failureDescription }) {
        super();
        Object.defineProperty(this, "result", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "failureDescription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.result = result;
        this.statusCode = statusCode;
        this.componentName = componentName;
        this.componentSource = componentSource;
        this.failureDescription = failureDescription;
    }
    prepare() {
        return {
            ...super.prepare(),
            result: this.result,
            statusCode: this.statusCode,
            componentName: this.componentName,
            componentSource: this.componentSource,
            failureDescription: this.failureDescription
        };
    }
}
